import { _APIS } from "apis";
import request from "request";
import { useState, useRef } from "react";
import emiter, { _EVENTS } from "../../../events";
import { DEFAULT_PAGE_INFO } from "consts";

export const useCSOrderListTemplate = () => {
  // 请求表格数据
  const search = (data: any) =>
    request.post(_APIS.NOTIFICATION.CS_ORDER_LIST.SEARCH, data);
  // 请求抽屉详情
  const getDetail = (data: any) =>
    request.post(_APIS.NOTIFICATION.CS_ORDER_LIST.DETAIL, data);
  // 添加回复
  const addReply = (params: any) =>
    request.post(_APIS.NOTIFICATION.CS_ORDER_LIST.REPLY, params);

  // form清空
  const searchFormReset = (form: any) => {
    emiter.emit(_EVENTS.NOTIFICATION.CS_ORDER_LIST.SEARCH, {
      ...form.getFieldsValue(),
      ...DEFAULT_PAGE_INFO
    });
  };

  // form搜索
  const searchFormFinish = (form: any) => {
    emiter.emit(_EVENTS.NOTIFICATION.CS_ORDER_LIST.SEARCH, {
      ...form.getFieldsValue(),
      ...DEFAULT_PAGE_INFO
    });
  };

  // 表格分页切换
  const tablePagination = (data: any) => {
    emiter.emit(_EVENTS.NOTIFICATION.CS_ORDER_LIST.SEARCH, data);
  };


  const refreshList = (data?: any) => {
    emiter.emit(_EVENTS.NOTIFICATION.CS_ORDER_LIST.SEARCH, data);
  }

  const getDrawerDetail = async (data: any) => {
    if (data.order_code && data.case_id) {
      const res = await getDetail({
        order_code: data.order_code, // 订单ID
        case_id: data.case_id, // 工单ID
      });
      return res;
    }
  };

  // 回复
  const replySubmit = async (data: any) => {
    await addReply({ ...data });
  };


  const tableActionView = async (data: any) => {
    try {
      const res = await getDrawerDetail(data);
      emiter.emit(_EVENTS.NOTIFICATION.CS_ORDER_LIST.VIEW, {
        details: res?.data,
      });
    } catch (err) {
      console.error("getDrawerDetail error", err);
    }
  };

  return {
    searchFormReset,
    searchFormFinish,
    search,
    tablePagination,
    tableActionView,
    getDrawerDetail,
    replySubmit,
    refreshList
  };
};
